var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkyscraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.11,194.42h82m-29-82.64V170M92.44,111.78V170m11.85-58.24V170m-.16-148.71v34.8M67.27,182.81H141M110.06,69.55H98.21V56.76h11.85ZM116,87.46H92.28V69.54H116ZM127.21,99H81.05V87.47h46.16Zm6.24,83.83H74.81V99h58.64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyscraper);
export default __webpack_public_path__ + "static/media/SKYSCRAPER.e9a6d76d686708ed9330ca4044736ddb.svg";
export { ForwardRef as ReactComponent };